"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentListModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var journey_services_1 = require("@ferry/journey-services");
var portal_core_1 = require("@ferry/portal-core");
var core_1 = require("@athena-portal/core");
var commonFunctions_1 = require("../../../commonFunctions");
var uuid_1 = require("uuid");
var rxjs_1 = require("rxjs");
var DocumentListModal = /** @class */ (function (_super) {
    __extends(DocumentListModal, _super);
    function DocumentListModal(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.DOC_BASE_PATH = "/resources/documents/";
        _this.docTypeEnumNameMap = (_a = {},
            _a[journey_services_1.DocTypeEnum.DOI] = "Annual document of car insurance",
            _a[journey_services_1.DocTypeEnum.IPID_PLUS] = "".concat(portal_core_1.resourcesHelper.THEME_NAME, " Insurance Product Information Document"),
            _a[journey_services_1.DocTypeEnum.IPID_ESSENTIALS] = "Essentials Product Information Document",
            _a[journey_services_1.DocTypeEnum.MLE] = "Motor Legal Expenses Leaflet",
            _a[journey_services_1.DocTypeEnum.DRIVE_AWAY_DOI] = "Drive Away Document of Insurance",
            _a[journey_services_1.DocTypeEnum.DRIVE_AWAY_IPID] = "Drive Away Insurance Product Information Document",
            _a);
        _this.documentVersions = new Map();
        _this.documents = [];
        _this.getDocumentPath = function (docType, version) {
            var theme = "".concat(portal_core_1.resourcesHelper.THEME_NAME);
            var brandName = (theme === 'Allianz')
                ? (0, commonFunctions_1.getThemeFromBrand)(_this.props.brand)
                : "".concat(portal_core_1.resourcesHelper.THEME);
            return "".concat(_this.DOC_BASE_PATH).concat(brandName, "/").concat(version, "/").concat(brandName, "_").concat(docType, ".pdf");
        };
        _this.state = {
            documents: []
        };
        _this.setAvailableDocTypesAndVersion();
        return _this;
    }
    DocumentListModal.prototype.componentDidMount = function () {
        this.handleDocuments();
        this.setDocumentSize();
    };
    DocumentListModal.prototype.componentDidUpdate = function (prevProps) {
        var _this = this;
        var propsChanged = prevProps.isMLEVisible !== this.props.isMLEVisible;
        if (propsChanged) {
            this.documentVersions.clear();
            this.setState({ documents: [] }, function () {
                _this.setAvailableDocTypesAndVersion();
                _this.handleDocuments();
            });
        }
    };
    DocumentListModal.prototype.render = function () {
        if (this.state) {
            var documentRender = this.state.documents.map(function (document, index) { return ((0, jsx_runtime_1.jsx)("li", { className: "mb-3", children: (0, jsx_runtime_1.jsxs)("a", { className: "btn btn-text d-flex text-align-left align-i-center documents-list-item margin-0", href: document.href, download: document.documentName, id: document.documentId, children: [(0, jsx_runtime_1.jsx)("span", { className: "file-icon" }), (0, jsx_runtime_1.jsxs)("p", { className: "mb-0", children: [document.documentName, ", PDF, ", document.documentFileSize] })] }) }, index)); });
            if (this.props.isAccordion) {
                return documentRender;
            }
            else {
                return (0, jsx_runtime_1.jsx)("ul", { className: "list-unstyled", children: documentRender });
            }
        }
        else {
            return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {});
        }
    };
    DocumentListModal.prototype.setAvailableDocTypesAndVersion = function () {
        var coverTier = this.props.coverTier;
        var isDriveAwayPolicy = journey_services_1.ProductsEnum.DRIVE_AWAY === this.props.productName;
        if (isDriveAwayPolicy) {
            this.availableDocTypes = [journey_services_1.DocTypeEnum.DRIVE_AWAY_DOI, journey_services_1.DocTypeEnum.DRIVE_AWAY_IPID];
        }
        else if (!isDriveAwayPolicy && coverTier === journey_services_1.ALLIANZ_ESSENTIALS) {
            this.availableDocTypes = [journey_services_1.DocTypeEnum.DOI, journey_services_1.DocTypeEnum.IPID_ESSENTIALS];
            if (this.props.isMLEVisible) {
                this.availableDocTypes.push(journey_services_1.DocTypeEnum.MLE);
            }
        }
        else {
            this.availableDocTypes = [journey_services_1.DocTypeEnum.DOI, journey_services_1.DocTypeEnum.IPID_PLUS, journey_services_1.DocTypeEnum.MLE];
        }
        this.setVersionByDate(this.availableDocTypes);
    };
    DocumentListModal.prototype.setVersionByDate = function (docVersions) {
        var _this = this;
        docVersions.forEach(function (type) {
            var documentVersion = journey_services_1.documentHelper.getDocumentVersionByDateAndType(_this.props.policyDate, type);
            if (documentVersion) {
                _this.documentVersions.set(type, documentVersion);
            }
        });
    };
    DocumentListModal.prototype.handleDocuments = function () {
        var _this = this;
        this.documentVersions.forEach(function (version, type) {
            _this.createDocument(type, version);
        });
        this.getPIUDocument();
    };
    DocumentListModal.prototype.createDocument = function (docType, version) {
        var _this = this;
        this.getDocumentSize(this.getDocumentPath(docType, version)).subscribe(function (size) {
            if (size) {
                var document_1 = {
                    key: (0, uuid_1.v4)(),
                    href: _this.getDocumentPath(docType, version),
                    documentId: "".concat(docType, "_DOC"),
                    documentName: _this.docTypeEnumNameMap[docType],
                    documentFileSize: size,
                };
                _this.setState(function (prevState) { return ({
                    documents: __spreadArray(__spreadArray([], prevState.documents, true), [document_1], false)
                }); });
            }
        });
    };
    DocumentListModal.prototype.getPIUDocument = function () {
        var _this = this;
        var privacyPath = "".concat(this.DOC_BASE_PATH, "LV_Allianz_how_we_use_personal_information.pdf");
        this.getDocumentSize(privacyPath).subscribe(function (size) {
            if (size) {
                var document_2 = {
                    key: (0, uuid_1.v4)(),
                    href: privacyPath,
                    documentId: journey_services_1.CAR_PIU_PDF_ID,
                    documentName: journey_services_1.CAR_PIU_PDF_NAME,
                    documentFileSize: size
                };
                _this.setState(function (prevState) { return ({
                    documents: __spreadArray(__spreadArray([], prevState.documents, true), [document_2], false)
                }); });
            }
        });
    };
    DocumentListModal.prototype.getDocumentSize = function (path) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            _this.baseRequestService.getDocumentSize(path).subscribe(function (response) {
                var size = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
                observer.next(size);
                observer.complete();
            });
        });
    };
    DocumentListModal.prototype.setDocumentSize = function () {
        var _this = this;
        this.documents.forEach(function (doc) {
            _this.baseRequestService.getDocumentSize(doc.href).subscribe(function (response) {
                doc.documentFileSize = (0, commonFunctions_1.formatFileSize)(response.xhr.getResponseHeader('content-length'));
            });
        });
        this.setState({
            documents: this.documents
        });
    };
    __decorate([
        (0, core_1.lazyInject)(journey_services_1.Types.BaseRequestService),
        __metadata("design:type", Object)
    ], DocumentListModal.prototype, "baseRequestService", void 0);
    return DocumentListModal;
}(React.Component));
exports.DocumentListModal = DocumentListModal;
//# sourceMappingURL=DocumentListModal.js.map